//@ts-nocheck
import React from "react";
import { Button } from "components/Buttons";

export const SuccessButton = (props) => <Button {...props} color="success" />;

SuccessButton.defaultProps = {};

SuccessButton.propTypes = Button.propTypes;
